import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        background: "transparent",
        border: "none",
        fontSize: "18px",
        cursor: "pointer",
        marginBottom: "20px",
      }}
    >
      ← Back
    </button>
  );
};

export default BackButton;
